import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, Stack, Switch, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../item.css";
import { M_Select } from "../../../../M_Components";

export const DropdownFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const handleInputChange = (value) => {
        // Convert to number if needed (MUI Select returns strings)
        let finalValue = value;
        if (value === "" || value === null) {
            finalValue = null;
        } else if (!isNaN(value)) {
            // Convert string numbers to actual numbers to match dropdownItemId type
            finalValue = Number(value);
        }

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: finalValue
            }
        });
    }

    const options = field.DropdownItems.filter(i => !i.isDeleted && !i.IsDeleted).map(i => {
        const captions = i.Captions || i.captions || {};
        const itemId = i.DropdownItemId || i.dropdownItemId;
        const label = captions[currentLanguage] || captions["en"] || itemId || "Unknown";
        return ({
            label: label,
            value: itemId
        })
    });

    // Get current value - ensure it matches the type in options (number)
    const currentValue = itemForm.form[field.Code];
    const displayValue = currentValue !== null && currentValue !== undefined ? currentValue : "";

    return (
        <div className="dropdown">
            <M_Select
                label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                value={displayValue}
                hasNone={!field.IsMandatory}
                options={options}
                disabled={isDisabled}
                onChange={(e) => handleInputChange(e.target.value)}
            />
        </div>
    )
}